export default __webpack_public_path__ + "static/Plots0062-123f7418c017aea34b30d150a260fa47.jpg";